import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useCurrentUserProfile } from '~/hooks/useCurrentUserProfile';
import {
  buildPermissionSet,
  hasAnyPermission,
  CN01_PLANTER_DASHBOARD_PERMISSIONS,
  DASHBOARD_ANALYTICS_ACCESS_PERMISSIONS,
} from '~/lib/permissions';
import { PlanterDashboard } from './PlanterDashboard';
import { AnalyticsDashboard } from './AnalyticsDashboard';

export function DashboardPage() {
  const { data: profile } = useCurrentUserProfile();
  const permissionSet = useMemo(
    () => buildPermissionSet(profile?.permissions),
    [profile?.permissions]
  );
  const isPlanterDashboard = hasAnyPermission(permissionSet, CN01_PLANTER_DASHBOARD_PERMISSIONS);
  const showAnalytics = hasAnyPermission(permissionSet, DASHBOARD_ANALYTICS_ACCESS_PERMISSIONS);

  if (isPlanterDashboard) {
    return <PlanterDashboard />;
  }

  if (showAnalytics) {
    return <AnalyticsDashboard />;
  }

  return (
    <Box>
      <Typography variant="h4" component="h1">
        Welcome to Tea Nursery portal
      </Typography>
    </Box>
  );
}
